import { FC } from "react";
import { Textarea } from "@chakra-ui/react";
import { useField } from "formik";
import { InputWrapperSimple } from "~/components";

interface Props {
  h?: string;
  id: string;
  label?: string;
  placeholder?: string;
}

export const TextInput: FC<Props> = ({ h, id, label, placeholder }) => {
  const [field, meta] = useField(id);
  const type = "text";
  const inputId = `${type}-input-${id}`;

  return (
    <InputWrapperSimple label={label} meta={meta} id={id} type={type}>
      <Textarea
        {...field}
        h={h}
        id={inputId}
        isInvalid={meta.touched && !!meta.error}
        placeholder={placeholder}
        variant="th-text-input"
      />
    </InputWrapperSimple>
  );
};
